define([
	'internal_util/Util',
	'lib/jquery'
], function (
	Util,
	jQuery
) {
	'use strict';

	/**
	 * NavigationView class
	 */
	return function () {
		var _view = jQuery(
				"<div id='skIdS_navigation-container'>" +
					"<span id='skIdS_navigation'></span>" +
					"<hr id='skIdS_navigation-delimiter'>" +
				"</div>");


		// public methods

		this.get = function () {
			return _view;
		};

		this.update = function (text) {
			if (Util.isValidString(text)) {
				_view.find('#skIdS_navigation').html(text);
			}
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/NavigationView.js
// module id = 18
// module chunks = 1